import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbSortChange } from 'mdb-angular-ui-kit/table';
import { FrattaleService } from 'src/app/services/frattale.service';
import * as Highcharts from 'highcharts';
import { TradingSystemGraficoWeeklyComponent } from '../../shared/trading-system-grafico-weekly/trading-system-grafico-weekly.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-m45',
  standalone: true,
  templateUrl: './m45.component.html',
  styleUrls: ['./m45.component.scss'],
  imports: [HighchartsChartModule, ReactiveFormsModule, MdbFormsModule,
    MdbSelectModule, CommonModule
  ]
})
export class M45Component implements OnInit {
  spread: number = 0;
  markets: any = []
  datiata: any = []
  tempData: any = []
  tempDataBuy: any = []
  tempDataSell: any = []
  numop: number = 0
  numops: number = 0
  perpos: number = 0
  ptot: number = 0
  ppop: number = 0
  maxprofit: number = 0
  maxloss: number = 0
  numopbuy: number = 0
  numopsbuy: number = 0
  perposbuy: number = 0
  ptotbuy: number = 0
  ppopbuy: number = 0
  maxprofitbuy: number = 0
  maxlossbuy: number = 0
  numopsell: number = 0
  numopssell: number = 0
  perpossell: number = 0
  ptotsell: number = 0
  ppopsell: number = 0
  maxprofitsell: number = 0
  maxlosssell: number = 0
  rawal: number = 0
  rawalbuy: number = 0
  rawalsell: number = 0
  kelly: number = 0
  kellybuy: number = 0
  kellysell: number = 0

  mercato: string = ''
  minuti = [0, 15, 30, 45]
  ora = [1, 2, 3, 4, 5, 6, 7, 8]
  loading: boolean = false

  giorni = [
    { id: 0, giorno: 'Tutti i giorni' },
    { id: 2, giorno: 'Lunedì' },
    { id: 3, giorno: 'Martedì' },
    { id: 4, giorno: 'Mercoledì' },
    { id: 5, giorno: 'Giovedì' },
    { id: 6, giorno: 'Venerdì' },
  ]

  formFiltri: FormGroup = new FormGroup({
    selMarket: new FormControl(null),
    selGiorno: new FormControl(0),
    ampiezzaOC: new FormControl(0),
    selMinuto: new FormControl(45),
    selOraclose: new FormControl(1),
    applicaSL: new FormControl(false),
    sl: new FormControl(0),
    applicaTP: new FormControl(false),
    tp: new FormControl(0),
  })

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}
  chartOptionsOrari: Highcharts.Options = {}
  chartOptionsPuntiOrari: Highcharts.Options = {}

  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  @ViewChild('chartWeek') chartWeek!: TradingSystemGraficoWeeklyComponent

  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
    this.service.getMarketsSymbols().subscribe(
      (res: any) => {
        if (res.res == 'ok') {
          this.markets = res['data']
        }
      }
    )
  }


  selectMarket() {
    this.loading = true
    let mkt = this.formFiltri.get('selMarket')?.value.toLowerCase()
    this.mercato = mkt.toUpperCase()
    this.spread = this.markets.find((el: any) => el.market == this.mercato).spread
    let m = this.formFiltri.get('selMinuto')?.value
    let ora = this.formFiltri.get('selOraclose')?.value
    let pip = this.markets.find((el: any) => el.market == this.mercato).pip
    this.service.reverseM45(mkt, m, ora).subscribe((data: any) => {
      console.log(data)
      this.loading = false
      data.data.map((el: any) => {
        el.punti = el.punti - this.spread * pip
      })
      this.datiata = data.data
      this.filtra()
    })
  }

  filtra() {
    let m = this.markets.find((el: any) => el.market == this.mercato)
    let pip = m.pip
    let dati: any[] = []
    this.datiata.forEach((val: any) => dati.push(Object.assign({}, val)))
    let giorno = this.formFiltri.get('selGiorno')?.value
    if (giorno > 0) {
      dati = dati.filter((el: any) => el.dayweek == giorno)
    }
    let ampiezza = this.formFiltri.get('ampiezzaOC')?.value
    if (ampiezza > 0) {
      dati = dati.filter((el: any) => Math.abs(el.pattern) >= ampiezza * pip)
    }
    let chkSL = this.formFiltri.get('applicaSL')?.value
    if (chkSL) {
      let sl = this.formFiltri.get('sl')?.value
      dati.forEach((el: any) => {
        if (parseFloat(el.vopen) < parseFloat(el.vclose)) { // sell
          if (parseFloat(el.vmax) > parseFloat(el.vclose) + parseFloat(sl) * parseFloat(pip)) {
            el.punti = -sl * +pip
            el.tipo = 'SL'
          }
        } else { // buy
          if (+el.vmin < +el.vclose - +sl * +pip) {
            el.punti = -sl * +pip
            el.tipo = 'SL'
          }
        }
        if (el.punti < -sl * +pip) { 
          console.log(el) 
        }
      })
    }
    let chkTP = this.formFiltri.get('applicaTP')?.value
    if (chkTP) {
      let tp = this.formFiltri.get('tp')?.value
      dati.forEach((el: any) => {
        if (!el.tipo) {
          if (parseFloat(el.vopen) < parseFloat(el.vclose)) { // sell
            if (parseFloat(el.vmin) < parseFloat(el.vclose) - parseFloat(tp) * parseFloat(pip)) {
              el.punti = +tp * +pip
              el.tipo = 'TP'
            }
          } else { // buy
            if (+el.vmax > +el.vclose + +tp * +pip) {
              el.punti = +tp * +pip
              el.tipo = 'TP'
            }
          }
        }
      })
    }
    this.tempData = dati
    this.popolaDatiTot(dati)
    this.popolaDatiBuy(dati.filter((el: any) => el.vclose < el.vopen))
    this.popolaDatiSell(dati.filter((el: any) => el.vclose > el.vopen))
    this.aggiornaGrafico(dati)
    this.filtraOrario(dati)
  }

  filtraOrario(dati: any) {
    let orari: any[] = []
    for (let i = 1; i < 23; i++) {
      let s1 = dati.reduce((acc: any, el: any) => {
        let ora = new Date(el.orap).getHours()
        if (ora == i) { acc += el.punti }
        return acc
      }, 0)
      orari.push({ name: i.toString(), y: s1 })
    }
    let numopOrarie : any[] = []
    for (let i = 1; i < 23; i++) {
      let s1 = dati.filter((el: any) => new Date(el.orap).getHours() == i).length
      numopOrarie.push({ name: i.toString(), y: s1 })
      /* if (s1 > 0) {
        numopOrarie[i-1].y = numopOrarie[i-1].y / s1
      } */
    }
    this.chartOptionsOrari = {
      title: {
        text: 'Orari'
      },
      chart: {
        type: 'column'
      },
      xAxis: {
        type: 'category'
      },
      series: [{
        name: 'Punti per Ora',
        data: orari,
        type: 'column'
      }]
    }
    this.chartOptionsPuntiOrari = {
      title: {
        text: 'Punti Op. per Ora'
      },
      chart: {
        type: 'column'
      },
      xAxis: {
        type: 'category'
      },
      series: [{
        name: 'Punti',
        data: numopOrarie,
        type: 'column'
      }]
    }
  }

  popolaDatiTot(dati: any[]) {
    let m = this.markets.find((el: any) => el.market == this.mercato)
    let pip = m.pip
    this.numop = dati.length
    this.numops = dati.filter((el: any) => el.punti > 0).length
    this.perpos = this.numops / this.numop * 100
    this.ptot = dati.reduce((a: any, b: any) => a + +b.punti, 0) / pip
    this.ppop = this.ptot / this.numop
    let d = dati.map((el: any) => el.punti)
    this.maxprofit = Math.max(...d)
    this.maxloss = Math.min(...dati.map((el: any) => el.punti))
    let sommapos = dati.reduce((a: any, b: any) => a + (b.punti > 0 ? b.punti : 0), 0) / pip
    this.rawal = (sommapos / this.numops) / ((sommapos - this.ptot) / (this.numop - this.numops))
    this.kelly = (this.perpos / 100 - (1 - this.perpos / 100) / (this.rawal))
  }

  popolaDatiBuy(dati: any[]) {
    this.tempDataBuy = dati
    let m = this.markets.find((el: any) => el.market == this.mercato)
    let pip = m.pip
    this.numopbuy = dati.length
    this.numopsbuy = dati.filter((el: any) => el.punti > 0).length
    this.perposbuy = this.numopsbuy / this.numopbuy * 100
    this.ptotbuy = dati.reduce((a: any, b: any) => a + +b.punti, 0) / pip
    this.ppopbuy = this.ptotbuy / this.numopbuy
    this.maxprofitbuy = Math.max(...dati.map((el: any) => el.punti))
    this.maxlossbuy = Math.min(...dati.map((el: any) => el.punti))
    let sommapos = dati.reduce((a: any, b: any) => a + (b.punti > 0 ? b.punti : 0), 0) / pip
    this.rawalbuy = (sommapos / this.numopsbuy) / ((sommapos - this.ptotbuy) / (this.numopbuy - this.numopsbuy))
  }

  popolaDatiSell(dati: any[]) {
    this.tempDataSell = dati
    let m = this.markets.find((el: any) => el.market == this.mercato)
    let pip = m.pip
    this.numopsell = dati.length
    this.numopssell = dati.filter((el: any) => el.punti > 0).length
    this.perpossell = this.numopssell / this.numopsell * 100
    this.ptotsell = dati.reduce((a: any, b: any) => a + +b.punti, 0) / pip
    this.ppopsell = this.ptotsell / this.numopsell
    this.maxprofitsell = Math.max(...dati.map((el: any) => el.punti))
    this.maxlosssell = Math.min(...dati.map((el: any) => el.punti))
    let sommapos = dati.reduce((a: any, b: any) => a + (b.punti > 0 ? b.punti : 0), 0) / pip
    this.rawalsell = (sommapos / this.numopssell) / ((sommapos - this.ptotsell) / (this.numopsell - this.numopssell))
  }

  aggiornaGrafico(dati: any[]) {
    let p = 0;
    let progr = dati.map((a: any) => {
      p += +a.punti
      return [a.orap, p]
    })
    this.chartOptions = {
      series: [{
        data: progr,
        type: 'line',
        turboThreshold: 100000
      }
      ]
    }
  }

  graficoTotale() {
    this.aggiornaGrafico(this.tempData)
  }

  graficoBuy() {
    this.aggiornaGrafico(this.tempDataBuy)
  }

  graficoSell() {
    this.aggiornaGrafico(this.tempDataSell)
  }

  onSortChange(event: MdbSortChange): void {
    console.log('sort change event', event);
    if (event.direction === 'none') {
      this.selectMarket()
      return
    } else {
      event.name = event.name.replace('.', '').toLowerCase()
      this.datiata = this.datiata.sort((a: any, b: any) => {
        let a1: number = a[event.name]
        let b1: number = b[event.name]
        if (event.direction === 'asc') {
          let c: number = a1 - b1 < 0 ? 1 : a1 - b1 > 0 ? -1 : 0
          return c
        }
        if (event.direction === 'desc') {
          let c: number = a1 - b1 < 0 ? -1 : a1 - b1 > 0 ? 1 : 0
          return c
        }
        return 0;
      });
    }
  }

}
